<template>
  <div class="login-container">
    <h2 class="headtitle">领班人广告连锁</h2>
    <!-- 欢迎标题和logo -->
    <div class="welcome-section">
      <img src="../assets/home.jpg" alt="微信Logo" class="wechat-logo">
      <h1 class="welcome-title">欢迎登录</h1>
    </div>
    
    <!-- 微信一键登录按钮 -->
    <button 
      class="wechat-login-btn"
      @click="handleWechatLogin"
    >
      <img src="../assets/wechat-icon.png" alt="微信图标" class="wechat-icon">
      微信一键登录
    </button>
  </div>
</template>

<script>
import {wxlogin} from '../api/mobile'
// import {wxlogintest} from '../api/mobile'



export default {
  data(){
    return {
        redirectUri:window.location.href,
        //redirectUri:'https://lbrgzh.gcaibang.com/mobilelogin',
    }
  },
  mounted(){
    this.handleCallback();
  },
  methods: {
    handleWechatLogin() {
        const redirectUri = encodeURIComponent(this.redirectUri);
        const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxaae2342645a29027&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
        window.location.href = authUrl
    },

    // handleWechatLogin() {
    //   wxlogintest({code:"1"}).then(res => {
    //       if(res.code == 1)
    //       {
    //           localStorage.setItem('mobiletoken', res.data.token)
    //           localStorage.setItem('moblieusername', res.data.name)
    //           this.$router.push('/moblie')
    //           this.$message.success('登录成功')
    //       }
    //   })
    // },

    // 处理回调逻辑
    handleCallback() {
      const urlParams = new URLSearchParams(window.location.search)
      const code = urlParams.get('code')

      if (code) {
        wxlogin({code:code}).then(res => {
            if(res.code == 1)
            {
                localStorage.setItem('mobiletoken', res.data.token)
                localStorage.setItem('moblieusername', res.data.name)
                this.$router.push('/moblie')
                this.$message.success('登录成功')
            }
            
        })
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f8f8f8;
  padding: 20px;
  box-sizing: border-box;
}

.headtitle{
    margin-bottom: 50px;
    color: #012db2;
}

.welcome-section {
  text-align: center;
  margin-bottom: 50px;
}

.wechat-logo {
  width: 80px;
  height: 80px;
  margin-bottom: 20px;
}

.welcome-title {
  font-size: 24px;
  color: #012db2;
  font-weight: normal;
  margin: 0;
}

.wechat-login-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  max-width: 300px;
  height: 50px;
  background-color: #07C160;
  color: white;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  box-shadow: 0 4px 12px rgba(7, 193, 96, 0.3);
  transition: all 0.3s ease;
}

.wechat-login-btn:active {
  transform: translateY(2px);
  box-shadow: 0 2px 6px rgba(7, 193, 96, 0.3);
}

.wechat-icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
  border-radius: 20%;
}
</style>